<template>
    <div class="card-share">
        <template v-if="show">
            <div class="card-img">
                <img class="img" :src="data.cardShareImg" >
            </div>
            <div class="tip-text">复制卡券号码后，进入App进行兑换</div>
            <div class="card-num">{{data.cdKey}}</div>
            <div class="copy-btn" @click="handleCopy(data.cdKey)">复制卡券号码</div>
            <input type="text" ref="copyInput" class="hidden-input">
        </template>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: true,
            data: {}
        }
    },
    mounted() {
        this.getCard()
    },
    methods: {
        async getCard() {
            const id = this.$route.params.id
            const res = await this.$http.getCard({ clientId :id }).catch(err => {
                return err.data
            })
            const { code, data } = res
            if (code === 1000 && data) {
                this.data = data
            } else {
                this.show = false
                this.$Toast.fail(res.message)
            }
        },
        handleCopy(value) {
            this.$refs.copyInput.value = value
            this.$refs.copyInput.select()
            const elText = document.execCommand('copy')
            if (elText) {
                // this.$Toast.success('复制成功')
                this.$Toast({
                    type: 'success',
                    message: '复制成功',
                    duration: 1000
                })
            } else {
                this.$Toast.fail('复制失败')
            }
        }
    }
}
</script>

<style scoped>
.card-share {
    width: 100%;
    min-height: 100vh;
    background: #ffffff;
}
.card-img {
    width: 100%;
    padding: 20px 20px 0;
    box-sizing: border-box;
}
.card-img .img {
    width: 100%;
    display: block;
}
.tip-text {
    box-sizing: border-box;
    color: rgba(0, 0, 0, .8);
    text-align: center;
    font-size: 14px;
    padding: 20px 0;
}
.card-num {
    width: 80%;
    padding: 10px 0;
    box-sizing: border-box;
    margin: 14px auto;
    text-align: center;
    border: 1px solid rgb(187, 187, 187, .4);
    border-radius: 6px;
    font-size: 14px;
}
.copy-btn {
    width: 180px;
    padding: 8px 0;
    box-sizing: border-box;
    background: rgb(164, 173, 179);
    color: #ffffff;
    text-align: center;
    border-radius: 4px;
    margin: 30px auto 0;
    font-size: 14px;
}
.hidden-input {
    opacity: 0;
    z-index: -100;
    height: 0;
}
</style>
